import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { ResetPasswordSubmitReq } from 'domain/payload/request/forgot-password/ResetPasswordSubmitReq';

const AuthService = () => {
  const resetPasswordSubmit = async (
    req: ResetPasswordSubmitReq
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.post(`/v1/public/auth/reset-password`, req);

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { resetPasswordSubmit };
};

export default AuthService;